'use client'

import {
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { ReactNode, useState } from 'react'
import { toast } from 'react-toastify'

import { AUTH, isHttpError, MessageType } from '@/shared/api'
import { useCommonDialog } from '@/shared/lib'
import { useErrorDialogStore } from '@/shared/store'

type Props = {
  children: ReactNode
}

const DEFAULT_MESSAGE = '오류가 발생했습니다.'

export const QueryProvider = ({ children }: Props) => {
  const { openMoveToSignInDialog } = useCommonDialog()
  const { actions } = useErrorDialogStore()

  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            refetchOnWindowFocus: false,
            retry: false,
          },
        },
        queryCache: new QueryCache({
          onError: (error, query) => {
            if (query.meta?.useCustomHandling) {
              return
            }

            if (!isHttpError(error)) {
              return toast(DEFAULT_MESSAGE)
            }

            if (error?.code === AUTH['002']) {
              openMoveToSignInDialog()

              return
            }

            const { type, content, title } = error.handler

            if (type === MessageType.TOAST) {
              toast(content)
            } else {
              actions.open({ title, content, type })
            }
          },
        }),
      }),
  )

  return (
    <QueryClientProvider client={queryClient}>
      {children}
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  )
}
